<div class="row answers">
  <div fxLayout="row" fxLayoutAlign="center center" >
    <div class="eval-container">
      <mat-tab-group>
        <mat-tab label="{{ 'HumanFace'|translate }}">
          <ng-template matTabContent>
            <div class="tab-content">
              <svg id="human-front" [attr.viewBox]="'0 0 137 400'" [attr.height]="600">
                <ng-container *ngFor="let path of frontPaths">
                  <path [attr.stroke-width]="path.borderSize"
                        [attr.stroke]="path.borderColor"
                        [attr.fill]="path.fill"
                        [attr.d]="path.path"
                        [attr.class]="'path'"
                        (click)="changePath(path, findByData(feedbackAnswers, path.identifier)); answerChanged(findByData(feedbackAnswers, path.identifier), false)">
                  </path>
                </ng-container>
              </svg>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="{{ 'HumanBack'|translate }}">
          <ng-template matTabContent>
            <div class="tab-content">
              <svg id="human-back" [attr.viewBox]="'0 0 137 400'" [attr.height]="600">
                <ng-container *ngFor="let path of backPaths">
                  <path [attr.stroke-width]="path.borderSize"
                        [attr.stroke]="path.borderColor"
                        [attr.fill]="path.fill"
                        [attr.d]="path.path"
                        [attr.class]="'path'"
                        (click)="changePath(path, findByData(feedbackAnswers, path.identifier)); answerChanged(findByData(feedbackAnswers, path.identifier), false)">
                  </path>
                </ng-container>
              </svg>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>

      <div class="body-slider">
        <ng-container *ngIf="activeFeedbackAnswer">
          <mat-slider thumbLabel min="0" max="10" step="1" tickInterval="1" showTickMarks discrete>
            <input matSliderThumb [formControl]="sliderControl" name="sliderControl" ngDefaultControl>
          </mat-slider>
          <span class="body-slider-info">{{ activeFeedbackAnswer.label }}</span>
        </ng-container>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="20px" class="mt-20">
    <div fxFlex="50">
      <button mat-stroked-button color="accent" (click)="nextQuestionClicked(true); feedbackQuestionService.backClicked.emit(question)" [disabled]="!hasAnsweredQuestion">
        <mat-icon>arrow_back</mat-icon>&nbsp;{{ 'Back' | translate }}
      </button>
    </div>

    <div fxFlex="50">
      <button mat-raised-button color="accent" (click)="nextQuestionClicked()" [disabled]="!isNextQuestionEnabled() || isSubmitting">{{ 'Next'|translate }} <mat-icon>arrow_forward</mat-icon></button>
    </div>
  </div>
</div>
